/**
 * Guest mode feature flag and public API path helpers.
 * VUE_APP_GUEST_MODE_ENABLED defaults to true when unset.
 */

function envFlag(key, defaultEnabled = true) {
  const raw = process.env[key];
  if (raw === undefined || raw === null || String(raw).trim() === '') {
    return defaultEnabled;
  }
  return String(raw).trim() !== 'false';
}

export function isGuestModeEnabled() {
  return envFlag('VUE_APP_GUEST_MODE_ENABLED', true);
}

export function isPublicGuestApiPath(url = '') {
  const path = String(url);
  return path.includes('/public/posts') || path.includes('/public/listings');
}

/** Shared post URL used for guest preview (/post/:postId). */
export function isGuestPostPath(path = '') {
  return /^\/post\/[^/]+\/?$/.test(String(path));
}

/** Guest-mode tracing — always on; filter console with `[GuestMode]`. */
export function guestDebug(step, payload = {}) {
  console.log('[GuestMode]', step, {
    path: typeof globalThis !== 'undefined' ? globalThis.location?.pathname : undefined,
    ...payload,
  });
}
